import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

interface CounterProps extends BoxProps {
  count: number | string;
  theme?: 'neutral' | 'primary' | 'menu-light' | 'menu-dark';
}

const Counter: React.FC<CounterProps> = ({ count, theme = 'neutral', ...rest }) => {
  return (
    <Box {...rest} className={cx(styles['counter'], styles[`counter--${theme}`])}>
      {count}
    </Box>
  );
};

export default Counter;
